<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
      @toggleClick="toggleSideBar" />
    <div class="right-menu">
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">{{ userName }} <span class="fs14">{{ `(${rouleName})` }}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item @click.native="gotoWechatAuth">
            <span>微信公众号第三方授权</span>
          </el-dropdown-item> -->
          <el-dropdown-item divided @click.native="checkRoule">
            <span>切换角色</span>
          </el-dropdown-item>
          <!-- <el-dropdown-item divided @click.native="checkEnterprise">
            <span>切换企业</span>
          </el-dropdown-item> -->
          <!-- <el-dropdown-item divided @click.native="pushNotification">
            <span>推送通知开关</span>
          </el-dropdown-item> -->
          <el-dropdown-item divided @click.native="modifyPwd">
            <span>修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="dib pt18 pr18 fs21" @click="jumpPageMessage" style="float: right;cursor: pointer;">

      <el-badge :value="messageCount" :hidden="messageCount == 0" class="item">
        <i class="el-icon-bell"></i>
      </el-badge>
    </div>
    <el-dialog title="切换角色" :visible.sync="dialogVisible" width="30%">
      <el-radio-group v-model="checkRouleId">
        <el-radio v-for="(item, index) in  rouleList" :key="index" :label="item.RoleId">{{ item.RoleName }}</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="toggleRoule">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="切换企业" :visible.sync="enterpriseFlag" width="30%">
      <!-- <el-radio-group v-model="enterpriseId">
        <el-radio v-for="(item,index) in  enlerpriseList" :key="index" :label="item.villages_id">{{ item.villages_name }}</el-radio>
      </el-radio-group> -->
      <!-- <el-cascader-panel :options="enlerpriseList" :props="propsCascader"></el-cascader-panel> -->
      <div>
        <label class="login-label2 db mb8">请选择公司</label>
        <el-select class="login-select" v-model="enterpriseId" placeholder="请选择公司" @change="changeEnterprise">
          <el-option v-for="item in enlerpriseList" :key="item.user_id" :label="item.villages_name" :value="item.user_id">
          </el-option>
        </el-select>
        <div>
          <el-radio-group v-model="checkRouleId" class="mt24" @change="changeRadioRoule">
            <el-radio v-for="(roleItem, index) in rouleList" :key="index" :label="roleItem.RoleId">{{ roleItem.RoleName}}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="enterpriseFlag = false">取 消</el-button>
        <el-button type="primary" @click="toggleEnterprise">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="推送通知开关" :visible.sync="notificationFlag" width="60%">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notificationFlag = false">取 消</el-button>
        <el-button type="primary" @click="surePush">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { session } from "@/utils/session";
import { erpWebApi } from "@/utils/request";
import { groupMsgNoticeRecord } from "@/api/menuList/index";

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    }
  },
  data() {
    return {
      userName: '',
      rouleList: '',
      rouleName: '',
      rouleId: localStorage.getItem('rouleId'),
      dialogVisible: false,
      checkRouleId: '',
      notificationFlag: false,
      checkAll: false,
      checkedCities: [],
      cities: ['租赁模块业务单类消息', '仓库模块业务单类消息', '维修模块业务单类消息', '基础维护模块业务单类消息', '审核单类消息', '工单类消息'],
      isIndeterminate: false,
      enlerpriseList: [],
      enterpriseId: '',
      enterpriseFlag: false,
      propsCascader: {
        value: 'villages_id',
        label: 'villages_name',
        children: 'UserRoles',
      },
      messageCount:0
      // rouleList: JSON.parse(localStorage.getItem('rouleList'))
    }
  },
  created() {
    this.userName = session.getUserName();
    this.rouleList = JSON.parse(localStorage.getItem('rouleList'));
    this.enlerpriseList = JSON.parse(localStorage.getItem('enterpriseList'));
    this.rouleList.forEach(item => {
      if (item.RoleId == this.rouleId) {
        this.rouleName = item.RoleName
      }
    })
    this.checkRouleId = this.rouleId;
    this.loadMessageNumber()
  },
  methods: {
    // 消息汇总
    loadMessageNumber() {
      var params = {
        "GroupType":"2",
        "NoticeUserId":localStorage.getItem('userId'),
        "IsRead":"0",
        "ClientType":"2",
        "pageIndex":1,
        "pageSize":20
      }

      groupMsgNoticeRecord(params).then(res=> {
        this.messageCount = res.Data.totalCount
        
      })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    //修改密码
    modifyPwd() {
      this.$router.push({ name: "UploadPwd" });
    },
    //退出登录
    logout() {
      this.$confirm("确定退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          session.removeSession();
          window.location.href = "/#/Login"
        })
        .catch(() => {
        });
    },
    async gotoWechatAuth() {
      var resp = await erpWebApi.getWxCallback({
        callBackUrl: window.location.origin + "/#/WechatAuthCallback",
      });
      this.wechatAuthUrl = resp;
      window.location.href = this.wechatAuthUrl;
    },
    jumpPageMessage() {
      this.$router.push({
        name: 'MessageList'
      })
      // this.$router.push({
      //   path:'MessageList'
      // })
    },
    //
    checkRoule() {
      this.rouleId = localStorage.getItem('rouleId');
      this.rouleList = JSON.parse(localStorage.getItem('rouleList'));
      // this.enlerpriseList = JSON.parse(localStorage.getItem('enterpriseList'));
      this.checkRouleId = this.rouleId;
      this.dialogVisible = true
    },
    // 切换企业
    checkEnterprise() {
      this.enlerpriseList = JSON.parse(localStorage.getItem('enterpriseList'));
      this.enterpriseId = localStorage.getItem("userId");
      this.rouleId = localStorage.getItem('rouleId');
      this.rouleList = JSON.parse(localStorage.getItem('rouleList'));
      this.checkRouleId = this.rouleId;
      this.enterpriseFlag = true;
    },
    toggleRoule() {
      // console.log(this.$store.state.tagsView.visitedViews);
      // this.$store.dispatch('tagsView/cleanAllTags', this.$route)
      this.rouleList.forEach(item => {
        if (item.RoleId == this.checkRouleId) {
          this.dialogVisible = false;
          localStorage.setItem('rouleId', item.RoleId);
          localStorage.setItem('IsAdmin', item.IsAdmin);
          window.location.replace('/#/home')
          window.location.reload(false)
          // this.$router.go('/home')
          // window.location.href = "/#/home";
          // location.href =  window.location.origin + '/#/Home'
        }
      })
    },
    // 确认切换公司
    toggleEnterprise() {
      var item = this.enlerpriseList.filter((x) => x.user_id == this.enterpriseId)[0];
      localStorage.setItem('rouleList', JSON.stringify(this.rouleList));
      session.setSession(item.user_id, item.user_name,item.villages_id, item.villages_name,item.code);
      this.rouleList.forEach(ele => {
        if (ele.RoleId == this.checkRouleId) {
          this.dialogVisible = false;
          localStorage.setItem('rouleId', ele.RoleId);
          localStorage.setItem('IsAdmin', ele.IsAdmin);
          window.location.replace('/#/home')
          window.location.reload(false)
        }
      })
    },
    changeEnterprise(id) {
      this.enlerpriseList.forEach(item=> {
        if(item.user_id == id){
          this.rouleList = item.UserRoles;
          // this.IsAdmin = item.UserRoles[0].IsAdmin;
          // this.rouleId = item.UserRoles[0].RoleId
        }
      })
    },
    changeRadioRoule() {},
    // 推送通知开关
    pushNotification() {
      this.notificationFlag = true;
    },
    surePush() {
      this.notificationFlag = false;
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cities : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue